import { ProfitType } from 'pages/QuoteView/Quoting/RequestQuickQuote/types';

import { SourceRow, Suggestion } from '../types';

export const formatMoney = (value: number): string =>
  `$${Math.round(value).toLocaleString()}`;

export const formatRange = (low: number, high: number): string =>
  `${formatMoney(low)} - ${formatMoney(high)}`;

// Matches CarrierPriceCalculator percent profit → sell price.
export const estimatedSuggestedSell = (
  buy: number,
  profitPercent: number,
  isQuoteCalculatorMarginEnabled: boolean
): number => {
  const profitDecimal = profitPercent / 100;

  if (isQuoteCalculatorMarginEnabled) {
    if (profitDecimal >= 1) {
      return buy;
    }
    return Math.round(buy / (1 - profitDecimal));
  }

  return Math.round(buy * (1 + profitDecimal));
};

export const sourceTableRows = (suggestion: Suggestion): SourceRow[] => [
  ...suggestion.sources,
];

// Flat dollar margins show as money; everything else is a percent.
export const formatSuggestedMargin = (
  suggestion: Suggestion,
  formatMoneyFn: (value: number) => string = formatMoney
): string =>
  suggestion.suggestedMarginType === ProfitType.Amount
    ? formatMoneyFn(suggestion.suggestedMargin)
    : `${suggestion.suggestedMargin}%`;
